var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2211_8000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 2.66812H2.66634C2.31272 2.66812 1.97358 2.8086 1.72353 3.05864C1.47348 3.30869 1.33301 3.64783 1.33301 4.00145V13.3348C1.33301 13.6884 1.47348 14.0275 1.72353 14.2776C1.97358 14.5276 2.31272 14.6681 2.66634 14.6681H11.9997C12.3533 14.6681 12.6924 14.5276 12.9425 14.2776C13.1925 14.0275 13.333 13.6884 13.333 13.3348V8.66812M12.333 1.66812C12.5982 1.4029 12.9579 1.25391 13.333 1.25391C13.7081 1.25391 14.0678 1.4029 14.333 1.66812C14.5982 1.93334 14.7472 2.29305 14.7472 2.66812C14.7472 3.04319 14.5982 3.4029 14.333 3.66812L7.99967 10.0015L5.33301 10.6681L5.99967 8.00145L12.333 1.66812Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2211_8000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.66fe5122a4b467ca8290fb2d6c9122ef.svg";
export { ForwardRef as ReactComponent };